// removed by extract-text-webpack-plugin
module.exports = {"loadingScreen":"LoadingScreen__loadingScreen___JdO1e","loadingIcon":"LoadingScreen__loadingIcon___1YGCK"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/common/loadingScreen/LoadingScreen.scss
// module id = 1997
// module chunks = 0